// extracted by mini-css-extract-plugin
export default {"zoomModal":"O3-z","image":"P3-z","button":"Q3-z","isOverlayShown":"R3-z"};